// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "._2cobKuiGKg04yLrBi6LeRI {\n  margin-left: 30px;\n}\n\n.WcXgP3R658U4K_Furg8aO {\n  display: inline-block;\n}\n\n._1RZPHT0-Gv5mmHG_mNaKD {\n  display: inline;\n}\n\n.dAIYb4GsceGzvdIMQ2M5R {\n  font-weight: bold;\n}\n\n.RvWRhr3nQTVf0S8x1SRwL {\n  margin: 0 30px;\n}\n\n.zQg4wb081WgcX1NaL7kvx {\n  display: inline-block;\n  margin-right: 3px;\n}\n", "",{"version":3,"sources":["Presidents.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,qBAAA;EACA,iBAAA;AACF","file":"Presidents.css","sourcesContent":[".axis {\n  margin-left: 30px;\n}\n\n.verticalInput {\n  display: inline-block;\n}\n\n.form {\n  display: inline;\n}\n\n.componentHeadline {\n  font-weight: bold;\n}\n\n.factors {\n  margin: 0 30px;\n}\n\n.factor {\n  display: inline-block;\n  margin-right: 3px;\n}\n"]}]);
// Exports
exports.locals = {
	"axis": "_2cobKuiGKg04yLrBi6LeRI",
	"verticalInput": "WcXgP3R658U4K_Furg8aO",
	"form": "_1RZPHT0-Gv5mmHG_mNaKD",
	"componentHeadline": "dAIYb4GsceGzvdIMQ2M5R",
	"factors": "RvWRhr3nQTVf0S8x1SRwL",
	"factor": "zQg4wb081WgcX1NaL7kvx"
};
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader/dist/cjs.js??ref--1-1!../node_modules/postcss-loader??ref--1-2!./components/Presidents/Presidents.css
// module id = 549
// module chunks = 37